const getServiceEndpoints = () => {
    return {
        APP_CENTER: '/apigateway/cmi-app-center-service',
    }
}

const getDevServiceEndpoints = () => {
    return {
        APP_CENTER: 'http://localhost:8082',        
    }
}

const getDevServiceEndpointsQA = () => {
    return {
        APP_CENTER: 'http://daylnxkbsa001:27456',        
    }
}
const getDevServiceEndpointsEureka = () => {
    return {
        APP_CENTER: 'http://daylnxkbsu002:37112',        
    }
}

export const API_END_POINT = {
    BASE_URL: process.env.NODE_ENV === 'development' ? getServiceEndpoints() : getServiceEndpoints()
}
